module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/our-writters/add-writter/add-writter.component.css
// module id = ./src/app/our-writters/add-writter/add-writter.component.css
// module chunks = main